import React from 'react'
import { AlertDialog, Button } from '@paintscout/ui'
import { useDialogs } from '@paintscout/ui-business'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined'
import type { PainterAdditionalWork } from './types'
import type { usePainterAdditionalWorkStyles } from './usePainterAdditionalWorkStyles'

interface PendingAdditionalWorkActionsProps {
  item: PainterAdditionalWork
  onEdit?: (id: string) => void
  onDelete?: (id: string) => void
  onViewMedia?: (id: string) => void
  classes: ReturnType<typeof usePainterAdditionalWorkStyles>
}

export default function PendingAdditionalWorkActions({
  item,
  onViewMedia,
  onEdit,
  onDelete,
  classes
}: PendingAdditionalWorkActionsProps) {
  const { openDialog, dismissDialog } = useDialogs()
  const canEdit = item.canEdit ?? true
  const canDelete = item.canDelete ?? true
  const hasAnyActions = canEdit || canDelete || !!onViewMedia

  if (!hasAnyActions) return null

  const handleDelete = () => {
    if (!item.isCreated) {
      onDelete?.(item.id)
      return
    }
    openDialog(AlertDialog, {
      title: 'Are you sure?',
      message: <>This will permanently delete {item?.name ? <strong>{item?.name}.</strong> : 'the item.'}</>,
      actions: [
        { label: 'Cancel', onClick: dismissDialog, variant: 'text', left: true },
        {
          label: 'Delete',
          onClick: () => {
            dismissDialog()
            onDelete?.(item.id)
          }
        }
      ]
    })
  }

  return (
    <div className={classes.awActions}>
      {onViewMedia && item.hasMedia && (
        <Button
          className={classes.awActionBtn}
          variant="dialog"
          size="small"
          icon={ImageOutlinedIcon}
          onClick={() => onViewMedia?.(item.id)}
        >
          View Media
        </Button>
      )}
      <div className={classes.awActionBtnGroup}>
        {canEdit && (
          <Button
            className={classes.awActionBtn}
            variant="dialog"
            size="small"
            icon={EditOutlinedIcon}
            onClick={() => onEdit?.(item.id)}
          >
            Edit
          </Button>
        )}
        {canDelete && (
          <Button
            className={classes.awActionBtn}
            variant="dialog"
            size="small"
            icon={DeleteOutlineIcon}
            onClick={handleDelete}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  )
}
